<template>
<div>
    <v-data-table :headers="headers" :items="userEntrancesByUserId != null ? userEntrancesByUserId.items : []" :items-per-page="20" class="elevation-2" hide-default-footer :loading="loading" loading-text="Идет загрузка... Пожалуйста подождите">
        <template slot="progress">
            <v-progress-linear color="red lighten-1" indeterminate></v-progress-linear>
        </template>
        <template v-slot:item.enterDate="{ item }">
            <span>{{ new Date(item.enterDate).toLocaleString() }}</span>
        </template>
    </v-data-table>
    <v-card elevation="1">
        <v-card-text class="py-0">
            <v-pagination v-model="currentPage" :length="totalPages" color="red lighten-1"></v-pagination>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
export default {
    name: 'UserEntrancesByUserId',
    props: {
        dateStart: String,
        dateEnd: String,
        userId: String
    },
    data: () => ({
        headers: [{
                text: "Дата входа",
                sortable: false,
                align: "center",
                value: "enterDate",
            },
            {
                text: "IP адрес",
                sortable: false,
                align: "center",
                value: "ipAddress",
            }
        ],
        currentPage: 1,
        totalPages: 1,
        loading: true,
    }),
    computed: {
        ...mapGetters({
            getUserEntrancesByUserId: "unload/GET_USER_ENTRANCE_BY_USER_ID",
        }),
        userEntrancesByUserId() {
            return this.getUserEntrancesByUserId;
        },
    },
    methods: {
        ...mapActions({
            generateUserEntrancesByUserId: "unload/GENERATE_USER_ENTRANCE_BY_USER_ID",
        }),
        async getUserEntranceByUserIdFromAPI(isNewPage = true) {
            await this.generateUserEntrancesByUserId({
                pageNumber: this.currentPage,
                pageSize: 20,
                dateStart: this.dateStart,
                dateEnd: this.dateEnd,
                userId: this.userId
            });
            if (!isNewPage) {
                this.totalPages = this.userEntrancesByUserId.totalPages;
                this.currentPage = this.userEntrancesByUserId.pageNumber;
            }
        },
        setLoading(state) {
            this.loading = state;
        },
    },
    watch: {
         dateStart: function(){
            this.setLoading(true);
                this.getUserEntranceByUserIdFromAPI(false);
            this.setLoading(false);
        },
        dateEnd: function(){
            this.setLoading(true);
                this.getUserEntranceByUserIdFromAPI(false);
            this.setLoading(false);
        },
        userId: function(){
            this.setLoading(true);
                this.getUserEntranceByUserIdFromAPI(false);
            this.setLoading(false);
        },
        currentPage: function () {
            this.setLoading(true);
            this.getUserEntranceByUserIdFromAPI();
            this.setLoading(false);
        },
    },
    async created() {
        this.setLoading(true);
        await this.getUserEntranceByUserIdFromAPI(false);
        this.setLoading(false);
    }
}
</script>
